import { useContext } from "react";
import { Button, Form, Input, Modal } from "antd";
import { useRequest } from "ahooks";
import { registerAdmin } from "helpers/backend_helper";
import { NotificationContext } from "context/notificationContext";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

const generatePassword = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
  return Array.from({ length: 12 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

const CreateAdminModal = ({ isOpen, onClose, onSuccess }: Props) => {
  const [form] = Form.useForm();
  const { openNotificationWithIcon } = useContext(NotificationContext);

  const { loading, run: create } = useRequest(registerAdmin, {
    manual: true,
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || "Something went wrong");
    },
    onSuccess: () => {
      openNotificationWithIcon("success", "Admin created successfully");
      form.resetFields();
      onSuccess();
      onClose();
    },
  });

  const handleFinish = (values: { email: string; firstName: string; lastName: string; password: string }) => {
    create(values.email, values.password, values.firstName, values.lastName);
  };

  const handleOpen = () => {
    form.setFieldValue("password", generatePassword());
  };

  return (
    <Modal
      title="Create new admin"
      open={isOpen}
      footer={null}
      onCancel={onClose}
      afterOpenChange={(open) => open && handleOpen()}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item name="firstName" label="First name" rules={[{ required: true, message: "First name is required" }]}>
          <Input placeholder="First name" />
        </Form.Item>
        <Form.Item name="lastName" label="Last name" rules={[{ required: true, message: "Last name is required" }]}>
          <Input placeholder="Last name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: "Email is required" },
            { type: "email", message: "Invalid email" },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true, message: "Password is required" }]}>
          <Input placeholder="Password" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Create
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAdminModal;
